export const SUPERADMIN_VIEWS = [
  {
    name: 'Farms (Admin)',
    path: '/farms',
  },
  {
    name: 'Users',
    path: '/users',
  },
  {
    name: 'Teams',
    path: '/teams',
  },
  {
    name: 'Crop Templates',
    path: '/templates',
  },
  { name: 'Materials & Fuel', path: '/inputs' },
  { name: 'Equipment & Infrastructure', path: '/capexes' },
  {
    name: 'Billing Report',
    path: '/billing-report',
  },
  {
    name: 'Portfolio Evaluator',
    path: '/portfolio-evaluator',
  },
  {
    name: 'Land Advisor',
    path: '/land-advisor',
  },
];
